/**
 * The event status moves — the fields one lifecycle step writes on the event
 * document, and nothing else. `useEvents` (publish, close, cancel) writes
 * them; the organizer strip's "Leállítás" back to a draft writes the same two
 * fields through `updateEvent`. The E2E seed
 * builds its published and closed events with the same function, so there is
 * no second idea of what "published" means on the document.
 *
 * Pure: `timestamp` is the caller's (the Firestore client's `serverTimestamp()`
 * in the app, the Admin SDK's `FieldValue.serverTimestamp()` in the seed). The
 * caller adds the actor stamp (`useEvents.withActor`).
 *
 *   published → status, publishedAt, updatedAt
 *   closed    → status, closedAt, updatedAt
 *   cancelled → status, updatedAt
 *   draft     → status, updatedAt   (unpublish)
 */
export const EVENT_STATUSES = Object.freeze(["draft", "published", "closed", "cancelled"]);

export function eventStatusPatch(status, { timestamp }) {
  if (!EVENT_STATUSES.includes(status)) throw new Error(`eventStatusPatch: unknown status "${status}"`);
  if (status === "published") return { status, publishedAt: timestamp, updatedAt: timestamp };
  if (status === "closed") return { status, closedAt: timestamp, updatedAt: timestamp };
  return { status, updatedAt: timestamp };
}
